<template>
  <!-- Begin page -->
  <div id="layout-wrapper">

    <header id="page-topbar">
      <div class="navbar-header">
        <div class="d-flex">
          <!-- LOGO -->
          <div class="navbar-brand-box">
            <a href="https://myshop.shockping.com" class="logo">
              <img src="/img/logo.png" alt="logo-sm-dark" height="22"/>
            </a>
          </div>
        </div>

        <!-- 로그인 상태 노출 -->
        <div class="d-flex">
          <div style="align-self: center;padding: 0 10px;" class="my_url">
            <div class="badge badge-soft-success" @click="go_home">
              <div v-if="login==1" style="padding:8px;cursor:pointer;"><i class="far fa-home-alt" style="padding-right: 3px"></i>https://{{shopid}}.mshp.in/home</div> <!-- 1:정상로그인 -->
              <div v-else-if="login==2" style="padding:8px;cursor:pointer;">샵 개설이 필요합니다.</div> <!-- 2:샵개설필요 -->
              <div v-else-if="login==3" style="padding:8px;cursor:pointer;">임시 로그인 상태입니다.</div> <!-- 3:임시로그인 -->
              <div v-else-if="login==9" style="padding:8px;cursor:pointer;">(세션 체크 에러) 관리자에 문의하세요.</div> <!-- 9:세션체크에러발생 -->
              <div v-else-if="login==0" style="padding:8px;cursor:pointer;" @click="login_confirm=true">로그인이 필요한 서비스입니다.</div> <!-- 0:비로그인 -->
              <div v-else style="padding:8px;cursor:pointer;" @click="login_confirm=true">로그인이 필요한 서비스입니다.</div>
            </div>
          </div>

          <button type="button" class="btn btn-sm px-3 font-size-17 d-lg-none header-item" data-bs-toggle="collapse" data-bs-target="#topnav-menu-content">
            <i class="fas fa-bars"></i>
          </button>

          <div v-if="login==1" class="dropdown d-inline-block user-dropdown my_dropdown">
            <button type="button" class="btn header-item font-size-17 waves-effect" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
              <i class="fas fa-user"></i>
              <i class="mdi mdi-chevron-down"></i>
            </button>
            <div class="dropdown-menu dropdown-menu-end">
              <!-- item-->
              <a class="dropdown-item" href="https://my.shockping.com/myshop"><i class="ri-user-line align-middle me-1"></i>내정보</a>
              <div class="dropdown-divider"></div>
              <a class="dropdown-item text-danger" href="https://m.shockping.com/api/user/logout/v2?url=https://home.shockping.com">
                <i class="ri-shut-down-line align-middle me-1 text-danger"></i>로그아웃
              </a>
            </div>
          </div>

        </div>
      </div>
    </header>

    <div class="topnav">
      <div class="container-fluid">
        <nav class="navbar navbar-light navbar-expand-lg topnav-menu">
          <div class="collapse navbar-collapse" id="topnav-menu-content">
            <ul class="navbar-nav">
              <li class="nav-item">
                <router-link class="nav-link" to='/'>
                  <i class="fas fa-home" style="padding-right: 5px;padding-bottom: 2px;"></i> 마이샵 홈
                </router-link>
              </li>
              <li class="nav-item">
                <router-link class="nav-link" to='/pages'>
                  <i class="far fa-window-maximize" style="padding-right: 5px;padding-bottom: 2px;"></i> 나의 페이지 관리
                </router-link>
              </li>
              <li v-show="brandbooster" class="nav-item">
                <router-link class="nav-link" to='/sns-blocks?brandbooster=1' style="padding-left:0;">
                  <i class="far fa-hashtag" style="padding-bottom: 2px;"></i> 브랜드부스터 SNS 관리
                </router-link>
              </li>
            </ul>
          </div>
        </nav>
      </div>
    </div>

    <!-- ============================================================== -->
    <!-- Start right Content here -->
    <!-- ============================================================== -->
    <div class="main-content" id="result">

      <div class="page-content">
        <div class="container-fluid">
          <div class="row">
            <div class="col-12">
              <div class="page-title-box d-flex align-items-center justify-content-between">
                <h4 class="mb-0">{{page_name}}</h4>

                <div class="page-title-right">
                  <ol class="breadcrumb m-0">
                    <li class="breadcrumb-item"><a href="javascript: void(0);">홈</a></li>
                    <li class="breadcrumb-item active">{{nav_name}}</li>
                  </ol>
                </div>

              </div>
            </div>
          </div>

          <router-view/>

          <div v-if="dlg_confirm" class="modal fade show" style="display: block;background-color:#00000055;">
            <div class="modal-dialog" role="document">
              <div class="modal-content">
                <div class="modal-header">
                  <h5 class="modal-title">{{dlg_title}}</h5>
                  <button type="button" class="btn-close" @click="dlg_confirm=false" aria-label="Close"></button>
                </div>
                <div class="modal-body" v-html="dlg_desc"></div>
                <div class="modal-footer">
                  <button type="button" @click="dlg_confirm_ok" class="btn btn-primary waves-effect waves-light">확인</button>
                  <button type="button" class="btn btn-light waves-effect" @click="dlg_confirm=false" data-bs-dismiss="modal">취소</button>
                </div>
              </div>
            </div>
          </div>

          <div v-if="login_confirm">
            <div class="modal fade show" style="display: block;background-color:#00000055;">
              <div class="modal-dialog">
                <div class="modal-content" v-if="login==1 || login==0"> <!-- 1:일반로그인, 0:비로그인 -->
                  <div class="modal-header">
                    <h5 class="modal-title mt-0">나만의 마이샵</h5>
                    <button type="button" class="btn-close" @click="login_confirm=false" aria-label="Close"></button>
                  </div>
                    <div class="modal-body">
                      <h5>마이샵 로그인이 필요한 기능입니다.</h5>
                      <p>인증없이 마이샵 홈을 둘러볼 수 있지만, 생성된 페이지는 일정 시간 이후 삭제되어 영구적으로 사용이 불가능합니다.</p>
                    </div>
                    <div class="modal-footer">
                      <button type="button" class="btn btn-light waves-effect" @click="do_test_login">로그인 없이 둘러보기</button>
                      <button type="button" class="btn btn-primary waves-effect waves-light" @click="do_login">마이샵 계정 로그인하기</button>
                    </div>
                </div>

                <div class="modal-content" v-if="login==3"> <!-- 3:임시로그인 -->
                  <div class="modal-header">
                    <h5 class="modal-title mt-0">나만의 마이샵</h5>
                    <button type="button" class="btn-close" @click="login_confirm=false" aria-label="Close"></button>
                  </div>
                  <div class="modal-body">
                    <h5>임시 로그인 상태입니다.</h5>
                    <p>영구 저장 하시려면 정식 로그인이 필요합니다.</p>
                  </div>
                  <div class="modal-footer">
                    <button type="button" class="btn btn-primary waves-effect waves-light" @click="do_login">마이샵 계정 로그인하기</button>
                  </div>
                </div>

                <div class="modal-content" v-else-if="login==2"> <!-- 2:샵개설필요 -->
                  <div class="modal-header">
                    <h5 class="modal-title mt-0">나만의 마이샵</h5>
                    <button type="button" class="btn-close" @click="login_confirm=false" aria-label="Close"></button>
                  </div>
                  <div class="modal-body">
                    <h5>마이샵 생성</h5>
                    <p>마이샵 주소를 생성해야 계속 진행할 수 있습니다. 아래 버튼을 클릭하여 주소를 생성해주세요.</p>
                  </div>
                  <div class="modal-footer">
                    <button type="button" class="btn btn-light waves-effect" @click="do_test_login">생성하지 않고 둘러보기</button>
                    <button type="button" class="btn btn-primary waves-effect waves-light" @click="do_make_myshop">마이샵 생성하기</button>
                  </div>
                </div>

              </div>
            </div>
          </div>

        </div>

        <footer class="footer">
          <div class="container-fluid">
            <div class="row">
              <div class="col-sm-12">
                © {{year}} myshop
                <span class="d-none d-sm-inline-block">
                  - HOME
                  <i class="mdi mdi-heart text-danger"></i>
                  by Mocoplex, Inc.
                </span>
              </div>
            </div>
          </div>
        </footer>

      </div>
      <!-- END layout-wrapper -->

    </div>
  </div>
</template>
<script>
import {mapGetters} from "vuex";

export default {
  computed: mapGetters({
    page_name: 'page_name',
    nav_name: 'nav_name',
    login: 'login', // 로그인 상태
    shopid: 'shopid', // 로그인 상태
  }),
  created() {
    if(this.login == 1) {
      // 로그인 상태에서 샵 생성여부를 확인
      // this.getInfo()
    }
  },
  mounted() {

    if(this.$route.query.brandbooster) this.brandbooster = true;

    this.year = new Date().getFullYear()

    var that = this
    this.$eventBus.$on('login_confirm', function () {that.login_confirm=true})
    this.$eventBus.$on('dlg_confirm', this.show_dlg_confirm)

    this.$eventBus.$on('info', this.my_info)
    this.$eventBus.$on('error', this.my_error)

    if(this.login == 0){ // 0: 비로그인상태
      this.go_home();
    }else if([1, 2, 3, 9].includes(this.login)){  // 1:정상로그인, 2:샵개설필요, 3:임시로그인, 9:세션체크에러발생
      // console.log('mounted login,', this.login);
    }
  },
  data: () => ({
    dlg_title:'',
    dlg_desc:'',
    dlg_confirm:false,
    dlg_confirm_callback:null,
    login_confirm:false,
    year:'',
    brandbooster: false,
  }),
  methods:{
    dlg_confirm_ok:function () {
      if(this.dlg_confirm_callback != null) {
        this.dlg_confirm_callback()
      }
      this.dlg_confirm = false
    },
    show_dlg_confirm:function (title, msg, callback) {
      this.dlg_title = title
      this.dlg_desc = msg
      this.dlg_confirm_callback = callback
      this.dlg_confirm = true
    },
    loaded_all:function () {
      // // 로그인 시스템 에러 확인
      // if(this.login == -10) {
      //   this.my_error('로그인 에러','시스템 문제로 계정인증에 실패하였습니다.')
      // }
    },
    do_make_myshop:function () {
      location.href = 'https://myshop.shockping.com/plan/start_mall?url=' + encodeURIComponent(location.href)
    },
    do_login:function () {
      location.href = '//my.shockping.com/user/login?url=' + encodeURIComponent(location.href)
    },
    do_test_login:function () {
      this.$http
          .post('/api_home/user/temporary')
          .then(function(){
            setTimeout(function(){
              location.reload();
            }, 1000);
          })
          .catch(err=>{
            console.log(err.response.data);
          })
    },
    my_info:function(title, msg){
      try{
        var a = window.toastr
        a.options = {
          closeButton: true,
          progressBar: false,
          positionClass: 'toast-bottom-right',
          showMethod: 'slideDown',
        };
        a.success(msg, title)
      }catch(e){
        console.log(e)
      }
    },
    my_error:function (title, msg) {
      try {
        var a = window.toastr
        a.options = {
          closeButton: true,
          progressBar: false,
          positionClass: 'toast-bottom-right',
          showMethod: 'slideDown',
        };
        a.error(msg, title)
      }catch(e){
        console.log(e)
      }
    },
    go_home:function(){
      if(this.login == 1 && this.shopid != undefined){ // 1:정상로그인
        let url = 'https://' + this.shopid + '.mshp.in'
        window.open(url, '_blank');
      }else if(this.login == 2){ // 2:샵개설필요
        location.href = 'https://myshop.shockping.com/plan/start_mall?url=' + encodeURIComponent(location.href)
      }else if(this.login == 3){ // 3:임시로그인
        this.login_confirm=true;
      }
      else if(this.login == 9){1} // 9:세션체크에러발생
      else if(this.login == 0){1} // 0:비로그인
    },
    // getInfo: function () {
    //   var url = "/api_mall/shopadm/get/myinfo"
    //   this
    //       .$http.get(url)
    //       .then(data => {
    //         var v = data.data
    //         if(v.shopid) {
    //           this.$store.commit('shopid', v.shopid)
    //         }
    //       }).catch(err => {
    //         //console.log(err)
    //       })
    // },
  }
}
</script>
<style>
footer {
  font-size: 12px;
}
</style>